import React from "react";
import { Div } from "components/Base";

const UnauthorizedAccess = ({
  message = "You don't have permission to view this section!"
}) => (
  <Div display="column.center.center" height={1} width={1} bg="white">
    <Div fs={7} fw={3}>
      uh Oh!
    </Div>
    <Div fs={5} py={4}>
      {message}
    </Div>
  </Div>
);

export default UnauthorizedAccess;
